var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error',{attrs:{"text":'Попробуйте повторить запрос через некоторое время или обратитесь к администратору.',"icon":'fa-network-wired'}},[_c('template',{slot:"message"},[_vm._t("message")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }